<template>
    <div class="flex-1">
        <skeleton v-if="planBookingPage === undefined" />
        <not-found v-else-if="planBookingPage === null" />
        <not-found
            v-else-if="planBookingPage.__typename === 'InvalidBookingPage'"
            :title="planBookingPage.title"
            :reason="planBookingPage.reason"
        />
        <not-found
            v-else-if="!planBookingPage.active"
            :reason="t('pages.inactivePlan')"
        />
        <purchase-agreement
            v-else
            :plan="planBookingPage"
        />
    </div>
</template>

<script setup lang="ts">
import { useRoute } from '#app'
import { computed } from 'vue'
import PurchaseAgreement from '~/components/PurchaseContract/Agreement/PurchaseAgreement.vue'
import { useQuery } from '@tanstack/vue-query'
import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import Skeleton from 'primevue/skeleton'
import NotFound from '~/components/NotFound/NotFound.vue'
import { useCurrentDate } from '~/composables/use-current-date'

import { useSelectedLanguage } from '~/composables/use-selected-language'
import { useI18n } from 'vue-i18n'
const route = useRoute()
const slug = computed(() => route.params.slug)
const activeFacility = useActiveFacility()
const { t } = useI18n({ useScope: 'global' })

const selectedLanguage = useSelectedLanguage()
const currentDate = useCurrentDate()
const reactiveDate = computed(() => currentDate.value.getDate())
const query = useRpQuery()
const { data } = useQuery({
    queryKey: [
        'AgreementsPageQuery',
        slug,
        activeFacility,
        reactiveDate,
        selectedLanguage
    ],
    queryFn: () =>
        query(
            graphql(/* GraphQL */ `
                query AgreementsPageQuery(
                    $bookingInput: PlanBookingPageInput!
                    $facilityId: ID!
                    $input: SimpleSpokeInput!
                    $language: Language!
                ) {
                    planBookingPage(input: $bookingInput) {
                        __typename
                        ... on InvalidBookingPage {
                            title
                            reason
                        }
                        ... on Plan {
                            active
                            ...PurchaseAgreementPlanFragment
                        }
                    }
                }
            `),
            {
                facilityId: activeFacility.value.id,
                input: {
                    facilityId: activeFacility.value.id
                },
                language: selectedLanguage.value,
                bookingInput: {
                    slug: slug.value,
                    facilityId: activeFacility.value.id,
                    planType: 'AGREEMENT'
                }
            }
        )
})

const planBookingPage = computed(() => {
    if (data.value === undefined) {
        return undefined
    }

    if (data.value.planBookingPage === null) {
        return null
    }

    return data.value.planBookingPage
})
</script>
